<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M109.358 88.3933C86.6708 83.8456 106.443 55.5954 115.784 58.161C127.921 61.4963 89.1378 111.476 23.793 73.2222"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M24.8985 69.1313C24.8985 69.1313 24.3741 57.7945 28.5017 57.9158C39.0123 58.2259 81.3002 64.3891 111.854 55.4996"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M30.8379 61.9419C30.8379 61.9419 82.3931 67.6088 101.283 61.4964"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M86.1673 73.1151V69.2074C86.1673 68.4265 85.5132 67.8062 84.7322 67.8485C82.9645 67.9415 81.0388 68.0205 78.9666 68.0712C78.2279 68.0909 77.6387 68.6943 77.6387 69.433V73.4393C77.6387 74.209 78.2759 74.8265 79.0484 74.8011C80.9825 74.7334 82.9363 74.6263 84.907 74.474C85.6175 74.4205 86.1645 73.8284 86.1645 73.1151H86.1673Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M75.5762 73.5295V69.5062C75.5762 68.7534 74.9644 68.1416 74.2116 68.1445C72.3846 68.1529 70.4731 68.1416 68.4798 68.1022C67.7157 68.0881 67.0898 68.6999 67.0898 69.4639V73.4393C67.0898 74.1723 67.6706 74.7756 68.4037 74.801C70.3068 74.8659 72.2493 74.8997 74.2172 74.8941C74.9672 74.8941 75.5762 74.2823 75.5762 73.5323V73.5295Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M95.9322 72.4159L97.2234 68.7309C97.5561 67.7808 96.778 66.8081 95.7771 66.9293C94.3392 67.1041 92.2134 67.3297 89.4899 67.5411C88.7822 67.5947 88.2324 68.1868 88.2324 68.8973V72.6555C88.2324 73.4675 88.9401 74.1019 89.7492 74.0088C91.4493 73.8143 93.1551 73.5803 94.8664 73.3096C95.3598 73.2307 95.7686 72.8867 95.935 72.4159H95.9322Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M37.1691 69.2074V66.6446C37.1691 65.9736 36.6814 65.4012 36.016 65.2997C34.829 65.1165 33.6308 64.9247 32.4241 64.7189C31.5924 64.578 30.834 65.218 30.834 66.061V68.3447C30.834 68.9677 31.2569 69.5119 31.8602 69.6641C32.8583 69.9179 34.0791 70.2139 35.5057 70.5353C36.3572 70.727 37.1691 70.0814 37.1691 69.2074Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M45.874 70.9329V67.8203C45.874 67.1295 45.3581 66.5487 44.673 66.4698C43.3901 66.3203 42.0904 66.1568 40.7766 65.982C39.959 65.8721 39.2344 66.5064 39.2344 67.3297V70.2139C39.2344 70.8652 39.6939 71.4262 40.3339 71.5503C41.5688 71.7928 42.8883 72.0352 44.2811 72.2777C45.1128 72.4215 45.8768 71.7815 45.8768 70.9357L45.874 70.9329Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.0247 73.2025V69.3202C65.0247 68.59 64.4468 67.9894 63.7165 67.9612C62.1715 67.8992 60.587 67.8231 58.9631 67.7272C58.1821 67.6821 57.5195 68.3024 57.5195 69.0862V72.8331C57.5195 73.538 58.0552 74.1244 58.7572 74.1893C60.3248 74.333 61.9347 74.4571 63.5784 74.5614C64.3622 74.6122 65.0247 73.9863 65.0247 73.2025Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.4577 72.3285V68.7564C55.4577 68.0459 54.9135 67.4538 54.203 67.4002C52.6411 67.279 51.051 67.138 49.4298 66.9802C48.6291 66.9012 47.9355 67.5299 47.9355 68.3335V71.6942C47.9355 72.3708 48.4318 72.9431 49.1 73.0418C50.6478 73.2674 52.2633 73.4816 53.9352 73.6818C54.7444 73.7777 55.4577 73.1461 55.4577 72.3285Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M38.6172 77.5161C38.6172 77.5161 65.4098 88.1367 89.1405 80.9614"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.545 57.0136C96.545 57.0136 93.142 49.2631 92.7671 47.9747C92.7671 47.9747 54.3981 51.7724 42.895 49.3618C42.0238 49.1785 41.1554 49.6663 40.8538 50.5037C40.1517 52.4575 38.9338 55.728 38.1641 57.0136"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M66.887 57.7917C69.4047 57.8086 71.5474 57.8058 72.974 57.803C73.9129 57.803 74.5839 56.898 74.3188 55.9986L73.504 53.2356C73.3123 52.5843 72.6864 52.167 72.0126 52.2347C70.6085 52.3785 69.0466 52.4715 67.3973 52.5251C66.7544 52.5448 66.2047 52.9988 66.0665 53.6275L65.5224 56.0832C65.3278 56.9572 65.9904 57.7889 66.887 57.7945V57.7917Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M62.5126 52.5786C61.1311 52.5702 59.7355 52.542 58.3569 52.5025C57.683 52.4828 57.091 52.9451 56.9472 53.6049L56.4284 55.9506C56.2367 56.8133 56.8823 57.6394 57.7676 57.6592C59.2224 57.693 60.6772 57.7212 62.0897 57.7409C62.7833 57.7522 63.381 57.2532 63.4966 56.5681L63.8913 54.2167C64.0351 53.3624 63.381 52.5843 62.5126 52.5786Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M45.6792 51.8343C45.0589 51.7892 44.5232 51.7469 44.0919 51.7131C43.3898 51.6567 42.7555 52.1275 42.606 52.8154L42.1126 55.0907C41.9407 55.8801 42.4679 56.6526 43.2686 56.7795C43.7874 56.8613 44.3766 56.9346 45.0279 57.0051C45.7666 57.084 46.4376 56.5709 46.5616 55.8406L46.962 53.4724C47.1001 52.6547 46.5052 51.8963 45.6792 51.8371V51.8343Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.8285 57.3659C50.8379 57.4223 51.898 57.4703 52.9862 57.5126C53.6911 57.5408 54.3085 57.0389 54.4269 56.3397L54.8301 53.9517C54.9711 53.12 54.3508 52.3531 53.5106 52.3136C52.4703 52.2629 51.4666 52.2093 50.5221 52.1529C49.8342 52.1134 49.2167 52.5786 49.0701 53.2525L48.5373 55.6546C48.3512 56.5004 48.9658 57.3152 49.8314 57.3631L49.8285 57.3659Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M78.4358 58.9279L76.1154 53.5936C75.7095 52.6576 76.3354 51.5975 77.3503 51.5016L93.5336 49.982"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M18.9316 77.8827C18.9316 77.8827 31.7429 77.1525 29.2985 78.5903C26.8541 80.0282 24.6691 84.6718 33.6855 84.1276C42.7019 83.5807 52.8122 83.6765 48.9863 85.402C45.1604 87.1274 50.2663 89.5944 59.7366 89.0474C69.2069 88.5005 81.2203 86.2873 76.8502 89.1687C72.4774 92.0529 80.1348 91.2043 86.6927 89.1687C93.2506 87.1331 102.397 85.2695 98.6412 88.5484C94.883 91.8273 105.822 91.0266 105.822 91.0266"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.6816 41.5436L86.4635 47.5686"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M74.6895 42.8744L76.4685 48.8994"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.0778 42.8744C85.0778 42.8744 79.0979 43.1761 77.4062 43.9119L78.1562 47.5687C78.1562 47.5687 84.5252 46.0603 86.104 46.345"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M61.9229 43.9091L59.377 48.4454"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M64.1008 45.2201L62.5332 47.8562C62.5332 47.8562 72.6125 47.2754 73.4978 47.5658L72.886 44.5547L64.1008 45.2201Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M20.1977 55.2458C20.1977 55.2458 14.246 53.3117 10 49.8411"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M22.6988 58.88C22.6988 58.88 18.0158 57.7072 14.8242 56.6809"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M25.5035 54.1209C25.5035 54.1209 18.8075 52.8578 16.084 50.5262"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M87.8386 41.6536C74.6861 36.308 60.6484 43.6751 60.6484 43.6751L74.7848 42.8744C74.7848 42.8744 81.3737 39.5813 87.8414 41.6536"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
